import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ButtonV2 } from '@eppendorf/vnls-react-components-preview';
import { ReactElement } from 'react';

interface ReportListEmptyStateProps {
  title: string;
  description: string;
  actionLabel: string;
  onActionClick: () => void;
}

export function ReportListEmptyState({
  title,
  description,
  actionLabel,
  onActionClick,
}: ReportListEmptyStateProps): ReactElement {
  return (
    <div className="box flex flex__jc--center flex__ai--center p-xxxl">
      <div
        className="flex flex__dir--column flex__ai--center text-align-center"
        style={{ maxWidth: '32rem' }}
      >
        <Icon
          name="generic"
          size={IconSizeClasses.Large}
          className="bg-gray-500 m-bottom-l"
        />

        <p className="m-bottom-m font-size-xl font-weight-medium">{title}</p>
        <p className="m-bottom-xxl">{description}</p>

        <ButtonV2 size="md" onPress={onActionClick}>
          {actionLabel}
        </ButtonV2>
      </div>
    </div>
  );
}
